export const PCP_SELECT = 'pcp_select'
export const SEARCH_SELECT = 'search_select'
export const WEBCONTENT_SELECT = 'webcontent_select'
export const REGULATORY_SELECT = 'regulatory_select'
export const MEDIALIBRARY_SELECT = 'medialibrary_select'